import { SecCodeModelDto as BoSecCodeModelDto } from '@treasury/api/bo';
import { SecCodeModelDto as ConsumerSecCodeModelDto } from '@treasury/api/channel';
import { exists } from '@treasury/utils';
import { DomainEntity } from '../../../shared';

export class SecCode extends DomainEntity<BoSecCodeModelDto | ConsumerSecCodeModelDto> {
    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    /**
     * Determines if the supplied DTO is using the BO or the Consumer shape
     */
    public isBoDto(): this is this & { dto: BoSecCodeModelDto } {
        const boDto = this.dto as BoSecCodeModelDto;
        return exists(boDto) && 'aid' in boDto;
    }

    public get id(): number | undefined {
        return this.isBoDto() ? this.dto.id : undefined;
    }

    public get code(): string {
        return this.dto.code;
    }

    public get description(): string {
        return this.dto.description;
    }
}
